module.exports = __webpack_public_path__ + "img/doloto.0dfdd2ec.svg";